(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stl-ask"] && !Shopify.designMode) return;
  try {
    
/* Slice 6b: the way into Shopify Inbox's chat. Bundled by Shopify into scripts.js, so it runs on
   every page, which is where the "Message Sophie" links are (the panel above, the FAQ page, the
   Contact page). Each link carries data-stl-chat and a real href (the Contact page, or the message
   box on the Contact page itself), which is what the click falls back to when the chat cannot
   open: the Inbox embed switched off under App embeds, blocked, or not loaded yet.

   What the Inbox embed is, measured on the build copy on 18 Oct 2026: one custom element,
   <shopify-chat>, from cdn.shopify.com/storefront/web-components/chat.js. It exposes show(),
   close() and an `open` attribute, and exports two parts, `activator` (its launcher) and `dialog`
   (the chat window). The three routes below are tried in that order. None of it is documented by
   Shopify, so every step is guarded and the href is the floor. Nothing here throws. */
(function () {
  if (window.__stlChat) return;
  window.__stlChat = true;

  var FLAG = 'data-stl-chat';
  var KEY = 'stl_chat';
  var html = document.documentElement;

  /* Opened once this visit: the section's CSS lets the launcher show from here on, so the shopper
     can get back to the conversation after closing the window. Measured 18 Oct 2026 in one tab
     session: the component carries a chat that is still open to the next page by itself
     (sessionStorage shopify-chat-open), but once closed it stays closed on every later page, and
     the conversation id survives, so the launcher is the way back in. sessionStorage, so a new
     visit starts with the corner clear again. */
  try {
    if (sessionStorage.getItem(KEY) === '1') html.setAttribute(FLAG, '');
  } catch (e) {}

  function remember() {
    html.setAttribute(FLAG, '');
    try {
      sessionStorage.setItem(KEY, '1');
    } catch (e) {}
  }

  function launcher(host) {
    var runtime = host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var root = runtime && runtime.shadowRoot;
    return root ? root.querySelector('[part~="activator"]') : null;
  }

  /** Opens the chat window. False when there is no chat on the page, so the link's href takes over. */
  function openChat() {
    var host = document.querySelector('shopify-chat');
    if (!host) return false;
    remember();
    if (typeof host.show === 'function') {
      try {
        host.show();
        return true;
      } catch (e) {}
    }
    var button = launcher(host);
    if (button) {
      button.click();
      return true;
    }
    host.setAttribute('open', '');
    return host.hasAttribute('open');
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var link = target && target.closest('[data-stl-chat]');
    if (!link || event.defaultPrevented) return;
    if (openChat()) event.preventDefault();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stl-home-promos"] && !Shopify.designMode) return;
  try {
    
  // The promo clip: muted, inline, looping, and only while it is on screen. Nothing loads until
  // the tile is near the viewport (preload="none" plus the first play()), so a shopper who never
  // scrolls past the hero never downloads it.
  (function () {
    var videos = document.querySelectorAll('video[data-stl-promo-video]');
    if (!videos.length || typeof IntersectionObserver === 'undefined') return;

    var reduce = null;
    try {
      reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch (e) {}

    function wantsMotion() {
      return !(reduce && reduce.matches);
    }

    function play(video) {
      if (!wantsMotion() || document.hidden) return;
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function pause(video) {
      if (!video.paused) {
        try {
          video.pause();
        } catch (e) {}
      }
    }

    var onScreen = new Set();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            onScreen.add(entry.target);
            play(entry.target);
          } else {
            onScreen.delete(entry.target);
            pause(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    Array.prototype.forEach.call(videos, function (video) {
      video.muted = true;
      // The reveal. Until a real frame is on screen the video stays transparent and the photo
      // under it is what the shopper sees, so the tile never needs a poster image.
      video.addEventListener('playing', function () {
        video.setAttribute('data-stl-playing', '');
      });
      observer.observe(video);
    });

    document.addEventListener('visibilitychange', function () {
      onScreen.forEach(function (video) {
        if (document.hidden) pause(video);
        else play(video);
      });
    });

    if (reduce && typeof reduce.addEventListener === 'function') {
      reduce.addEventListener('change', function () {
        onScreen.forEach(function (video) {
          if (wantsMotion()) play(video);
          else pause(video);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stl-home-skirt-hero"] && !Shopify.designMode) return;
  try {
    
  // The hero clip: muted, inline, looping. It autoplays from the markup; this script reveals it
  // once a real frame is on screen (until then the still shows), pauses it when the tab is hidden
  // and keeps the still in place under "reduce motion".
  (function () {
    var videos = document.querySelectorAll('video[data-stl-skirt-video]');
    if (!videos.length) return;

    var reduce = null;
    try {
      reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch (e) {}

    function wantsMotion() {
      return !(reduce && reduce.matches);
    }

    function play(video) {
      if (!wantsMotion() || document.hidden) return;
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function pause(video) {
      if (!video.paused) {
        try {
          video.pause();
        } catch (e) {}
      }
      video.removeAttribute('data-stl-playing');
    }

    Array.prototype.forEach.call(videos, function (video) {
      video.muted = true;
      video.addEventListener('playing', function () {
        if (!wantsMotion()) {
          pause(video);
          return;
        }
        video.setAttribute('data-stl-playing', '');
      });
      if (wantsMotion()) play(video);
      else pause(video);
    });

    document.addEventListener('visibilitychange', function () {
      Array.prototype.forEach.call(videos, function (video) {
        if (document.hidden) pause(video);
        else play(video);
      });
    });

    if (reduce && typeof reduce.addEventListener === 'function') {
      reduce.addEventListener('change', function () {
        Array.prototype.forEach.call(videos, function (video) {
          if (wantsMotion()) play(video);
          else pause(video);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stl-page-size-guide"] && !Shopify.designMode) return;
  try {
    
/* Size guide: the select swaps which style's table is shown. Every table is already in the page,
   so with JavaScript off the default style's table is still there and still readable. */
(function () {
  if (window.__stlSizeGuide5a) return;
  window.__stlSizeGuide5a = true;
  /* one conversion table per guide: a page's own AUS / US / EURO rows are dropped, the site-wide
     table under the measurements stays (same rule as the product page modal, 24 Sep) */
  var dropConversionTables = function (root) {
    var conv = /^(aus?|au\s*\/|aus\s*\/|us|usa|uk|euro?|eu|size)\b/i;
    var measure = /\b(cm|inch|inches|bust|waist|hip|hips|length|sleeve|chest|shoulder|rise|inseam)\b|\d+\s*(cm|in)\b/i;
    Array.prototype.forEach.call(root.querySelectorAll('.stl-sg-body table'), function (table) {
      var rows = table.querySelectorAll('tr');
      if (!rows.length || measure.test(table.textContent || '')) return;
      var labelled = 0;
      Array.prototype.forEach.call(rows, function (row) {
        var first = row.cells && row.cells[0] ? (row.cells[0].textContent || '').trim() : '';
        if (conv.test(first)) labelled += 1;
      });
      if (labelled >= Math.max(2, rows.length - 1)) table.parentNode.removeChild(table);
    });
  };
  var start = function () {
    dropConversionTables(document);
    var roots = document.querySelectorAll('[data-stl-sizeguide]');
    Array.prototype.forEach.call(roots, function (root) {
      var pick = root.querySelector('[data-stl-sg-pick]');
      if (!pick) return;
      var scope = root.parentNode || document;
      pick.addEventListener('change', function () {
        var want = pick.value;
        Array.prototype.forEach.call(
          scope.querySelectorAll('[data-stl-sg-guide]'),
          function (el) {
            el.hidden = el.getAttribute('data-stl-sg-guide') !== want;
          }
        );
      });
      root.setAttribute('data-stl-sizeguide', 'ready');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stl-page-story"] && !Shopify.designMode) return;
  try {
    
/* Slice 5a page behaviour. Everything here is inert when its elements are absent, so the bundle
   costs nothing on the other pages of the site. */
(function () {
  if (window.__stlPages5a) return;
  window.__stlPages5a = true;

  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  /* ---- Sophie's pinned Instagram carousel (mock 6.1d) ----
     Wrap-around both ways, smooth scroll, snap-driven index sync, tap the right half to advance
     and the left half to go back. No timers, no autoplay, no storage. */
  function carousel(root) {
    var track = root.querySelector('[data-stl-sc-track]');
    if (!track) return;
    var n = track.children.length;
    if (!n) return;
    var col = root.closest('.stl-sc-col') || root.parentNode;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-stl-sc-dots] span'));
    var counts = Array.prototype.slice.call(col.querySelectorAll('[data-stl-sc-count]'));
    var i = 0;

    function sync() {
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('stl-is-on', k === i);
      for (var j = 0; j < counts.length; j++) counts[j].textContent = i + 1 + ' / ' + n;
    }
    function go(k) {
      i = ((k % n) + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      sync();
    }
    track.addEventListener(
      'scroll',
      function () {
        if (!track.clientWidth) return;
        var k = Math.round(track.scrollLeft / track.clientWidth);
        if (k !== i && k >= 0 && k < n) {
          i = k;
          sync();
        }
      },
      { passive: true }
    );
    Array.prototype.forEach.call(col.querySelectorAll('[data-stl-sc-prev]'), function (b) {
      b.addEventListener('click', function () {
        go(i - 1);
      });
    });
    Array.prototype.forEach.call(col.querySelectorAll('[data-stl-sc-next]'), function (b) {
      b.addEventListener('click', function () {
        go(i + 1);
      });
    });
    track.addEventListener('click', function (e) {
      var r = track.getBoundingClientRect();
      go(e.clientX > r.left + r.width / 2 ? i + 1 : i - 1);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(i + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(i - 1);
      }
    });
    sync();
    root.setAttribute('data-stl-carousel', 'ready');
  }

  /* ---- the Our story section bar (mock 6.1b) ----
     The mock set the active link from the hash and scrolled with a 30ms timer and a hand-computed
     offset. The offset is scroll-margin-top in the CSS instead, so only the active class is left. */
  function rail() {
    var bars = document.querySelectorAll('[data-stl-abrail]');
    if (!bars.length) return;
    function paint() {
      var anchor = (location.hash || '').replace('#', '') || 'story';
      Array.prototype.forEach.call(bars, function (bar) {
        Array.prototype.forEach.call(bar.querySelectorAll('a[data-stl-sec]'), function (a) {
          a.classList.toggle('stl-is-on', a.getAttribute('data-stl-sec') === anchor);
          if (a.getAttribute('data-stl-sec') === anchor) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      });
    }
    paint();
    window.addEventListener('hashchange', paint);
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-stl-carousel]'), carousel);
    rail();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
